<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface NoSelectionProps {
  title?: string
  message?: string
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { DocumentPlusIcon } from '@heroicons/vue/24/outline'
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '#ui-kit/ui/empty'

const props = withDefaults(defineProps<NoSelectionProps>(), {
  title: 'Nothing selected',
  message: 'Select an item above to get started.',
})
</script>

<template>
  <Empty :class="props.class">
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <DocumentPlusIcon aria-hidden="true" />
      </EmptyMedia>

      <EmptyTitle>{{ title }}</EmptyTitle>

      <EmptyDescription v-if="message">{{ message }}</EmptyDescription>
    </EmptyHeader>
  </Empty>
</template>
